// add redirect here
import { NOT_FOUND } from 'redux-first-router';
import { fetchData } from './utils';

const handleDispatch = (dispatch, type, data) => (data === null ? dispatch({ type: NOT_FOUND })
  : dispatch({ type, payload: { data } }));

// might want to group related routes together and import them instead (ex. gift-guide ones)
export default {
  
  DEFAULT_LANDER: {
    path: '/',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const data = await fetchData(`/api/lander`);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },
  LANDER: {
    path: '/better-off-with-an-ally',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'LANDER_FETCHING' });
      const data = await fetchData(`/api/lander`);
      handleDispatch(dispatch, 'LANDER_FETCHED', data);
    },
  },

  DEFAULT_ARTICLE: {
    path: '/:article',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'ARTICLE_FETCHING' });
      const {
        location: {
          payload: {
            article,
          },
        },
      } = getState();

      // figure out how to pull query string from location.payload (might be a redux-first-router thing)
      const data = await fetchData(`/api/${article}`);
      handleDispatch(dispatch, 'ARTICLE_FETCHED', data);
    },
  },

  ARTICLE: {
    path: '/better-off-with-an-ally/:article',
    thunk: async (dispatch, getState) => {
      dispatch({ type: 'ARTICLE_FETCHING' });
      const {
        location: {
          payload: {
            article,
          },
        },
      } = getState();

      // figure out how to pull query string from location.payload (might be a redux-first-router thing)
      const data = await fetchData(`/api/${article}`);
      handleDispatch(dispatch, 'ARTICLE_FETCHED', data);
    },
  },
};
